import React, { useEffect, useState } from 'react';
import { showError, showSuccess } from 'utils/notifications';
import { ImagePicker } from 'react-file-picker';
import styles from './index.module.scss';
import { uploadFile } from 'services/api/common';
import ActionButton from 'components/ActionButton';
import { isBase64 } from 'utils';

const ImageUploadComponent = (
  {
    src,
    entityId = '',
    toggleModal,
    uploadAPI,
    forceShowUploadButton,
    onFileSelect,
  }:
  {
    entityId?: string;
    src: string;
    toggleModal?: () => void;
    uploadAPI: (entityId: string, image: any) => void;
    forceShowUploadButton?: boolean;
    onFileSelect?: Function;
  },
) => {
  const [file, setFile] = useState<string | File>();
  const [loading, setLoading] = useState(false);
  const [showUploadButton, setShowUploadButton] = useState(false);

  useEffect(() => {
    if (src?.length) {
      setFile(src);
    }
  }, [src]);

  const isPreviewMode = () => {
    return isBase64(src) && forceShowUploadButton;
  };
  
  useEffect(()=>{
    if(isPreviewMode()){
      setShowUploadButton(true);
    }
  }, [src]);

  const onSelectFile = (base64) => {
    setFile(base64);
    setShowUploadButton(true);
    if(onFileSelect){
      onFileSelect(base64);
    }
  };

  const onError = (error) => {
    showError(error.toString());
  };

  const uploadDocument = async () => {
    setLoading(true);
    try {
      const image = await uploadFile(file);
      await uploadAPI(entityId, image);
      setShowUploadButton(false);
      showSuccess('Image uploaded successfully.');
    } catch (e) {
      showError(e.message || e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {file ? (
        <img onClick={toggleModal && toggleModal} className="uploaded-image" src={file?.toString()} alt={'Item image'} />
      ): (
        <div className={styles['no-image-message']}>No Image</div>
      )}
      <ImagePicker
        extensions={['jpg', 'jpeg', 'png', 'ico']}
        dims={{ minWidth: 100, maxWidth: 16000, minHeight: 100, maxHeight: 16000 }}
        maxSize={15}
        onChange={onSelectFile}
        onError={onError}
      >
        <i className={'fa fa-pencil'} />
      </ImagePicker>
      {showUploadButton && (
        <ActionButton
          active={!loading}
          onClick={uploadDocument}
          isLoading={loading}
          text={'Upload'}
        />
      )}
    </>
  );
};

export default ImageUploadComponent;
